<template>
  <div class="work-algorhythm">

    <div class="section-wrap">
      <div class="grid-2">
        <div class="bg-dark d-f jc-c">
          <div class="d-g ai-c as-c"><AlgoLogoSpin/></div>
        </div>
        <div class="pad-3 bg-dark d-g ai-c as-c"><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fmisc%2Fimage%20403.png?alt=media&token=a8de4e43-7adf-4ef5-a76a-da45558ddafe" alt=""/></div>
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light pad-1">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fdesktop%2FFrame%2073.webp?alt=media&token=5c98dd05-20f9-4e1d-bf37-5cb5f698ae22" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fmobile%2FFrame%2026.webp?alt=media&token=86342b33-d480-4815-beb0-a5396b1474ce" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="grid-2">
        <div class="pad-2 bg-light"><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fdesktop%2FFrame%2082.webp?alt=media&token=8e3876e0-5356-40d7-923d-d8bf51ca3726" alt=""/></div>
        <div class="pad-2 bg-light"><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fdesktop%2FFrame%2081.webp?alt=media&token=6feedf18-62a3-45bb-bba4-2827509f0b52" alt=""/></div>
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light pad-1">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fdesktop%2FFrame%2074.webp?alt=media&token=b4245984-47ab-40ed-88b2-30e4ce787f1e" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light pad-1">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fdesktop%2FFrame%2075.webp?alt=media&token=9d158ed0-3643-4efb-89e7-d7fbc1f5f5e1" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="grid-4-mix-1 bg-light">
        <div class="div1 pad-2" style="align-self: center; justify-self: right;"><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fdesktop%2FFrame%2081.webp?alt=media&token=6feedf18-62a3-45bb-bba4-2827509f0b52" alt=""/></div>
        <div class="div2 pad-2" style="padding-bottom: 0; justify-self: left;"><img class="w-mob" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fmobile%2FIMG_0341.webp?alt=media&token=ddacf5d7-fa89-45a3-9407-6fb61df7d596" alt=""/></div>
        <div class="div3 pad-2" style="padding-top: 0; justify-self: right;"><img class="w-mob" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fmobile%2FIMG_0343.webp?alt=media&token=b8b171a1-bd78-4a3e-91ca-4db16f9344a5" alt=""/></div>
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light pad-1">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fdesktop%2FFrame%2076.webp?alt=media&token=3cd0829a-9256-49df-8761-2071b1fe1c95" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light pad-1">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fdesktop%2FFrame%2077.webp?alt=media&token=c93ba879-c8d1-4e9d-bdae-1ddb19d0145e" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="grid-4 bg-light">
        <div class="pad-2" style="padding-bottom: 0; justify-self: right;"><img class="w-mob" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fmobile%2FIMG_0310.webp?alt=media&token=63a203fe-a54c-4e0f-a19d-da7195d51305" alt=""/></div>
        <div></div>
        <div></div>
        <div class="pad-2" style="padding-top: 0; justify-self: left;"><img class="w-mob" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fmobile%2FIMG_0330.webp?alt=media&token=426c4426-aa1b-4c06-a6db-647bf4a99763" alt=""/></div>
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light pad-1">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fdesktop%2FFrame%2078.webp?alt=media&token=dffeec5e-32a2-40ec-9f84-3cd2b97cfaec" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light pad-1">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fdesktop%2FFrame%2079.webp?alt=media&token=b720f189-d94d-42a3-b52f-f5bdb9a87251" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fmobile%2FFrame%2026%20(1).webp?alt=media&token=d159d836-eef1-430f-8b15-d7eea793c5ef" alt="">
      </div>
    </div>

    <div class="section-wrap">
      <div class="col-1 bg-light pad-1">
        <img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fdesktop%2FFrame%2083.webp?alt=media&token=c4f93942-50e2-4a7d-a53f-d00b0417f723" alt="">
      </div>
    </div>

    <!-- <div class="section-wrap">
      <div class="grid-4">
        <div class="pad-2 bg-light"><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fdesktop%2FFrame%2079.webp?alt=media&token=b720f189-d94d-42a3-b52f-f5bdb9a87251" alt=""/></div>
        <div class="pad-2 bg-light"><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fdesktop%2FFrame%2079.webp?alt=media&token=b720f189-d94d-42a3-b52f-f5bdb9a87251" alt=""/></div>
        <div class="pad-2 bg-light"><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fdesktop%2FFrame%2079.webp?alt=media&token=b720f189-d94d-42a3-b52f-f5bdb9a87251" alt=""/></div>
        <div class="pad-2 bg-light"><img class="w-100" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Falgorhythm%2Fdesktop%2FFrame%2079.webp?alt=media&token=b720f189-d94d-42a3-b52f-f5bdb9a87251" alt=""/></div>
      </div>
    </div> -->

    <!-- <div class="section-wrap">
      <div class="col-1 bg-light pad-1">
        <img class="w-100" src="" alt="">
      </div>
    </div> -->



  </div>
</template>

<script>
import AlgoLogoSpin from '@/components/work/assets/AlgoLogoSpin.vue';

export default {
  name: 'WorkAlgorhythm',
  components: {
    AlgoLogoSpin
  },
  data() {
    return {
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/scss/_vars.scss";
@import "@/scss/_mixins.scss";
@import "@/scss/_classes.scss";


</style>
